export default class FormError {
  constructor(options = {}) {
    this.validable = this.validable
    this.name = options.name
    this.message = options.message
  }
}
